const expandAll = ({ ids }) =>
  ids.reduce((acc, curr) => ({ ...acc, [curr]: true }), {});

export default expandAll;
